<template>
  <div class="layout-with-centered-max-width-child">
    <div>
      <div>
        <div v-if="loadingStarted">
          <loading></loading>
        </div>
        <div v-else-if="loadingSuccessful">
          <div class="confirmation-container">
            <div class="each-row">
              <span class="font-secondary heading">Thank you for signing up with Bimileap!</span>
            </div>
            <div class="each-row">
              <span>Account activation is now complete! Now create a study and begin exploring your ideas.</span>
            </div>
            <div class="each-row">
              <div class="extra-button-padding">
                <router-link class="contact-button" :to="contactUs">
                  <a class="font-secondary">Contact Us</a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="loadingFailed">
          <div class="centered-row">
            <ErrorPage>
              <div slot="header">ERROR</div>
              <div slot="message">Sorry, there was an error loading the page</div>
            </ErrorPage>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    GET_BACKEND_URL,
    LOADING_COMPLETED_FAILURE,
    LOADING_COMPLETED_SUCCESS,
    LOADING_STARTED, R_NAME_CONTACT
  } from "../../services/constants"
  import ErrorPage from "./ErrorPage"
  import http from "../../services/axios"

    export default {
        name: "ConfirmationPage",
      components: {ErrorPage},

      created(){
        let userID = this.$route.params.userID
        let uniqueString = this.$route.query.confString

        http.post(this.$store.getters[GET_BACKEND_URL](`user/confirm/${userID}/${uniqueString}`)).then(response => {
          this.loadingStatus = response.data.success ? LOADING_COMPLETED_SUCCESS : LOADING_COMPLETED_FAILURE
        }).catch(err => {
          console.error(err)
          this.loadingStatus = LOADING_COMPLETED_FAILURE
        })
      },

      data(){
        return{
          loadingStatus: LOADING_STARTED
        }
      },

      computed: {
        loadingStarted() {
          return this.loadingStatus === LOADING_STARTED
        },
        loadingSuccessful() {
          return this.loadingStatus === LOADING_COMPLETED_SUCCESS
        },
        loadingFailed() {
          return this.loadingStatus === LOADING_COMPLETED_FAILURE
        },
        contactUs(){
          return { name: R_NAME_CONTACT }
        }
      },

    }
</script>

<style scoped lang="scss">

  @import "../../scss/main";

  .confirmation-container{
    padding: 5% 8%;
  }

  .heading{
    color: $red-2;
    font-weight: bold;
    font-size: 17px;
  }

  .each-row{
    padding: 1.5% 0;
  }

  .extra-button-padding{
    padding: 10px 0;
  }

  .contact-button{
    background: $red-2;
    color: $white-1;
    text-decoration: none;
    padding: 8px 18px;
    border: 2px solid $red-2;
    border-radius: 3px;
    font-size: 13px;
    font-weight: bold;
    line-height: 15px;
    text-align: center;
  }


</style>
